const dateTimeFormatter = new Intl.DateTimeFormat('nb-NO', {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
});

export const formatLocaleDateTimeCompact = (date: Date) => {
	return dateTimeFormatter.format(date);
};

const currencyFormatter = new Intl.NumberFormat('nb-NO', {
	style: 'currency',
	currency: 'NOK',
	currencySign: 'accounting',
});

export const formatLocaleCurrency = (fractionlessAmount: number) => {
	return currencyFormatter.format(fractionlessAmount / 100);
};
